import React from 'react'
import TermText from '../../Components/TermText/TermText'

const Terms = () => {
  return (
    <div className='term'>
      <TermText />
    </div>
  )
}

export default Terms
